module.exports = __webpack_public_path__ + "img/kg.f33d1ced.svg";